import { reactive, watchEffect } from "vue";
import { useI18n } from "vue-i18n";

/**
 * 获取品牌相关的环境变量
 * 根据当前语言自动选择中文或英文版本
 * 返回响应式对象，当语言切换时会自动更新
 */
export const useBrandConfig = () => {
  const { locale } = useI18n();

  const brandConfig = reactive({
    brandFullName: "",
    brandShortName: "",
    systemFullName: "",
    systemShortName: "",
    monitoringSystemName: import.meta.env.VITE_MONITORING_SYSTEM_NAME,
  });

  const updateBrandConfig = () => {
    const isChinese = locale.value === "zh-CN";

    brandConfig.brandFullName = isChinese
      ? import.meta.env.VITE_BRAND_FULL_NAME_CN
      : import.meta.env.VITE_BRAND_FULL_NAME_EN;

    brandConfig.brandShortName = isChinese
      ? import.meta.env.VITE_BRAND_SHORT_NAME_CN
      : import.meta.env.VITE_BRAND_SHORT_NAME_EN;

    brandConfig.systemFullName = isChinese
      ? import.meta.env.VITE_SYSTEM_FULL_NAME_CN
      : import.meta.env.VITE_SYSTEM_FULL_NAME_EN;

    brandConfig.systemShortName = isChinese
      ? import.meta.env.VITE_SYSTEM_SHORT_NAME_CN
      : import.meta.env.VITE_SYSTEM_SHORT_NAME_EN;
  };

  // 初始化
  updateBrandConfig();

  // 监听语言变化
  watchEffect(() => {
    updateBrandConfig();
  });

  return brandConfig;
};
